import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { AuthPageLayout } from '../components/AuthPageLayout';

export function PendingApprovalPage() {
  const navigate = useNavigate();

  return (
    <AuthPageLayout>
      <div className="flex flex-col items-center text-center lg:items-start lg:text-left gap-4">
        <div className="w-14 h-14 rounded-full bg-amber-50 border border-amber-100 flex items-center justify-center">
          <Clock className="w-7 h-7 text-amber-600" aria-hidden />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Registrierung wird geprüft</h1>
          <p className="text-sm text-slate-500 mt-2 leading-relaxed">
            Deine Anfrage wurde erfolgreich übermittelt. Ein Administrator prüft dein Konto und
            gibt es frei. Du kannst dich danach ganz normal einloggen.
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={() => navigate('/login', { replace: true })}
        className="w-full mt-6 rounded-xl bg-[#3b82f6] px-4 py-3 text-sm font-semibold text-white hover:bg-blue-600 transition-colors shadow-sm"
      >
        Zurück zum Login
      </button>
    </AuthPageLayout>
  );
}
